/**
****************************************************************************************
Project: Readabl
File: RenderRectangle.js
Description: This component will render the bounding box in the pdf.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React, { useState, useEffect } from "react";

const RenderRectangle = (props) => {

    const [dimensions, updateDimensions] = useState([]);

    useEffect(() => {
        let dim = (props.coordinates || []).map(m => {
            return calculateBoundingDimensions(m.vertices, props.imageDimensions?.width, props.imageDimensions?.height, m.color, m.selectedId)
        });
        updateDimensions(dim);
    }, [props.coordinates]);

    const calculateBoundingDimensions = (coords = {}, width, height, color, selected) => {
        // calculating the bounding cordinates
        const textWidth = coords.x2 - coords.x1;
        const textHeight = coords.y2 - coords.y1;

        return {
            width: Number((textWidth * width).toFixed(0)),
            height: Number((textHeight * height).toFixed(0)),
            x: Number((coords.x1 * width).toFixed(0)),
            y: (Number(coords.y1 * height)),
            color: color,
            selected
        };
    };

    return (dimensions || []).map((m, i) => (<rect
        className="pdf-viewer-cursor-pointer"
        tabIndex="0"
        ref={props.ref}
        id={m.selected || props.id}
        key={props.key}
        x={m.x}
        y={m.y}
        width={m.width}
        height={m.height}
        style={{
            fill: props.highlight ? (m.color || "black") : "none",
            fillOpacity: props.highlight ? 0.5 : 0,
            // stroke: props.color || "red",
            // strokeWidth: 1.5,
        }}
    />))
}

export default RenderRectangle;